import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { OrderDataProvider } from 'libs/core/src/lib/data-provider/order.data-provider';
import { UserDataProvider } from 'libs/core/src/lib/data-provider/user.data-provider';
import { LoaderEnum } from 'libs/core/src/lib/enum/loader.enum';
import { OrderHelper } from 'libs/core/src/lib/helper/order.helper';
import { LoaderService } from 'libs/core/src/lib/service/loading.service';
import { AuthStateService } from 'libs/core/src/lib/state/auth.state.service';
import { OrderStateService } from 'libs/core/src/lib/state/order.state.service';
import { FormDataBuilderInterface } from 'libs/shared/src/lib/component/login/interface/form-data.builder.interface';
import { LoginComponent } from 'libs/shared/src/lib/component/login/login.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { CustomFormBuilder } from './form.builder';
import { ErrorHandlerService } from 'libs/core/src/lib/service/error-handler/error-handler.service';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from 'libs/core/src/lib/service/navigation/navigation.service';

@Component({ standalone: false, selector: 'app-login', templateUrl: './login.component.html' })
export class CustomLoginComponent extends LoginComponent implements OnInit {
  showLoginPanel = false;
  isLogged = false;
  showResetPasswordSuccessPopup = false;

  constructor(
    protected authStateService: AuthStateService,
    protected userDataProvider: UserDataProvider,
    protected orderDataProvider: OrderDataProvider,
    protected orderStateService: OrderStateService,
    protected loaderService: LoaderService,
    protected modalService: BsModalService,
    protected orderHelper: OrderHelper,
    protected errorHandlerService: ErrorHandlerService,
    protected translateService: TranslateService,
    protected navigationService: NavigationService
  ) {
    super(
      authStateService,
      userDataProvider,
      orderDataProvider,
      orderStateService,
      loaderService,
      modalService,
      orderHelper,
      errorHandlerService,
      translateService
    );
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.authStateService.state$.subscribe((authState) => {
      this.isLogged = this.authStateService.userIsLoggedAndTokenIsValid();
    });

    this.remindPasswordProcessState.subscribe((success) => {
      if (success) {
        this.showResetPasswordSuccessPopup = true;
      }

      this.loaderService.hideLoader(LoaderEnum.MAIN);
    });
  }

  getFormGroup(formDataBuilderInterface: FormDataBuilderInterface): FormGroup {
    return new CustomFormBuilder().getForm(formDataBuilderInterface);
  }

  redirectTo(route: 'register' | 'resetPassword') {
    this.loaderService.hideLoader(LoaderEnum.MAIN);
    this.navigationService.goTo(['user', route]);
  }

  forgotPasswordClick(event: Event) {
    event.preventDefault();
    this.formSubmitAttempt = true;

    const passwordField = this.loginForm.controls['password'];

    if (passwordField && passwordField.hasValidator(Validators.required)) {
      passwordField.removeValidators(Validators.required);
      passwordField.setErrors(null);
    }

    if (this.loginForm.valid) {
      this.loaderService.showLoader(LoaderEnum.MAIN);
      this.remindPassword();
    }
  }

  signInClick(event: Event) {
    event.preventDefault();
    this.formSubmitAttempt = true;

    const passwordField = this.loginForm.controls['password'];
    if (passwordField && !passwordField.hasValidator(Validators.required)) {
      passwordField.addValidators(Validators.required);
      passwordField.updateValueAndValidity();
    }

    this.onSubmit();
  }
}
